import * as Plugins from './plugins';

export const persist = {
    Plugins
};
